import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-m max-md:heading-s mb-1 !font-[450] max-md:mb-2',
    description: 'heading-s max-md:heading-xs mb-6 max-md:!font-[450]',
    field: '',
    ratingContainer: '-mx-1 flex',
    starButton:
      'text-icon-secondary-medium group relative inline-block cursor-pointer px-1 transition-colors',
    starIcon: 'group-hover:[&>path]:fill-brand-300 size-10',
    starIconFilled: '[&>path]:fill-brand-300 size-10',
    starFilled:
      'text-icon-star pointer-events-none absolute top-0 left-1 overflow-hidden',
    error: 'heading-s text-text-error'
  }
});
